import { post, get } from 'aws-amplify/api';

export async function searchCourses(course) {
    const apiName = 'shankapi';
    const path = `/search/courses_v2/${course}`; 
    const options = { // OPTIONAL
        headers: { 'Content-Type': 'application/json'}, // OPTIONAL
        response: false
    };

    let response = await get({apiName, path, options}).response;
    let jsonResponse =  await response.body.json();
    return jsonResponse.map(x => x._source)
}

export async function getCourse(courseName, city, state) {
    const apiName = 'shankapi';
    const path = `/course/${courseName}/${city}/${state}`; 
    const options = { // OPTIONAL
        headers: { 'Content-Type': 'application/json'}, // OPTIONAL
        response: false // OPTIONAL (return the entire Axios response object instead of only response.data)
    };

    let response = await get({apiName, path, options}).response;
    let jsonResponse =  await response.body.json();

    return jsonResponse;
}